import React from "react";
import { FrameworkImage } from "./styled-component";
import { Link } from "react-router-dom";
import './project.css'

export function Project({ project }) {
  return (
    <Link to={`/projects/${project.id}`} style={{textDecoration : "none"}}>
      <div className="Project">

      <FrameworkImage state={project.type} /> 

        <div className="Project_TextBox">
          <div className="Project_TextBox_Title">{project.title}</div>
          <div className="Project_TextBox_Description">{project.description}</div>
       
        </div>

      </div>
    </Link>
  );
}
